import { FC } from "react";

import { ClassSessionCategory } from "components/server-types";
import { t } from "i18n/i18n";
import { PillButton } from "mds/components/PillButton";
import { useIsMdOrLarger } from "mds/hooks/use-responsive";
import { useAppSelector } from "store/index";
import { selectClassSessionCategoryBySectionId } from "store/selectors";
import { Link } from "utils/routing";
import { sectionHomeUrl } from "utils/urls";

export const SessionInProgressButton: FC<{ sectionId: string }> = ({ sectionId }) => {
  const isSmallScreen = !useIsMdOrLarger();
  const classSessionCategory = useAppSelector((state) =>
    selectClassSessionCategoryBySectionId(state, sectionId),
  );

  if (
    !classSessionCategory ||
    (classSessionCategory === ClassSessionCategory.VIRTUAL && isSmallScreen)
  ) {
    return null;
  }

  return (
    <PillButton
      as={Link}
      eventName="View Session in Progress"
      kind="blue"
      size="xs"
      to={sectionHomeUrl(sectionId)}
    >
      {t("home.session_in_progress")}
    </PillButton>
  );
};
